import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { useControlledField } from '@frontend/design-system';
import { AudioPicker } from '../audio-picker/audio-picker';
import { SettingsCard, SettingsSection } from '../common/settings-card';

export const PromptCard = ({
  onPromptChange,
  tenantId,
  greetingId,
  condensed,
  disabled = false,
}: {
  onPromptChange: (newPromptId: string) => void;
  tenantId: string;
  greetingId: string;
  condensed?: boolean;
  disabled?: boolean;
}) => {
  const { t } = useTranslation('phone');

  const greetingIdDropDownProps = useControlledField({
    type: 'dropdown',
    value: greetingId,
    onChange: (value) => {
      onPromptChange(value);
    },
  });

  return (
    <SettingsCard
      condensed={condensed}
      title={t('Phone Tree Prompt')}
      description={t(
        'Select a prompt with the available options. This message will play when callers reach your phone tree.'
      )}
    >
      <SettingsSection css={{ width: 'auto' }}>
        <AudioPicker
          widths={{ field: 320, scrubber: 320 }}
          field={greetingIdDropDownProps}
          disabled={disabled}
          css={css`
            display: flex;
            container-type: inline-size;
            & > div {
              width: 320px;
            }

            @container (max-width: 500px) {
              flex-wrap: wrap;
            }
          `}
          tenantId={tenantId}
          allowedOptions={{ add: true, standard: false, custom: true }}
          name='greetingMediaId'
          labels={{
            placeholder: t('Select Prompt'),
          }}
        />
      </SettingsSection>
    </SettingsCard>
  );
};
